/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./side-nav.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box, media } from '@atlaskit/primitives/compiled';
import { useMatchMedia } from '../../../common/ui';
var styles = {
  background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
export var SideNav = function SideNav() {
  var isAboveMediumScreen = useMatchMedia(media.above.md);
  return isAboveMediumScreen ? /*#__PURE__*/React.createElement(Box, {
    xcss: styles.background
  }, /*#__PURE__*/React.createElement(Image, null)) : null;
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 296,
    height: 473,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 5.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 9,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 17.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 48.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 52.96,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 60.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 91.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 95.96,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 103.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 134.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 138.96,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 146.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 9,
    x: 20,
    y: 189,
    fill: "#596773",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 43,
    x: 18,
    y: 215,
    fill: "#1C2B41",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M22 220.5h32v32H22z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 26,
    y: 224,
    fill: "#05C",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1868DB",
    d: "M18 229h2.66v15.96H18z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 66,
    y: 232.5,
    fill: "#05C",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M22 263.5h32v32H22z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 26,
    y: 267,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 66,
    y: 275.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M22 306.5h32v32H22z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 26,
    y: 310,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 66,
    y: 318.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M20 349.5h32v32H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 64,
    y: 361.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 392.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4,
    y: 396.96,
    fill: "#38414A",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 44,
    y: 404.5,
    fill: "#454F59",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 435.5h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    fillRule: "evenodd",
    d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.333 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFDBF8",
    fillOpacity: 0.28,
    d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 8,
    x: 44,
    y: 447.5,
    fill: "#454F59",
    rx: 3.99
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h296v473H0z"
  }))));
};